/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, color } from 'utils/styles';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// VERTICAL BAR 2 STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
	inner: {
		borderRadius: 'inherit',
		display: 'block',
		width: '100%',
		height: '100%',
		'& .bar': {
			background: color.white,
			transition: 'height .8s linear 0s, background .3s linear 0s'
		},
		'&.selected-true': {
			'& .bar.foreground': { 
				background: color.brand 
			},
			'&.correct-false': {
				'& .bar.foreground': { background: color.red }
			},
			'&.correct-true': {
				'& .bar.foreground': { background: color.green }
			}
		},
		// '&.correct-false': {
		// 	'& .bar.foreground': { background: '#e52727' }
		// },
		// '&.correct-true': {
		// 	'& .bar.foreground': { background: '#63913f' }
		// }
		'&.selected-false': {
			'&.finished-true': {
				'&.correct-true': {
					'& .bar.foreground': { transitionDelay: '1.6s', background: color.green },
				}
			}
		}

	},
	bar: {
		borderRadius: 'inherit',
		display: 'block',
		opacity: '.8',
		position: 'absolute',
		bottom: '0',
		left: '0',
		width: '100%',
		height: '0%' // dynamic, should come from component
	},
	number: {
		fontSize: pxToEm(14),
		position: 'absolute',
		bottom: pxToEm(-25),
		left: '0',
		textAlign: 'center',
		width: '100%'
	}
};
